// Shared frame→time formatter for the canvas workflow surface.
//
// Used by:
//   - buildElementGraph (TimelineElementNode label like "0:11 → 0:16")
//   - EditorCanvasSli's "Previewing at ..." chip
//
// Both surfaces must display the SAME value for the same frame, otherwise
// a node labelled "0:11 → 0:16" can pair with a chip reading "0:10" when
// the underlying frame is 316 (10.53s) — visually contradictory.
//
// Rounding rule: round to nearest second (Math.round). This matches the
// existing TimelineElementNode label, which is what the user already reads
// off the workflow graph; the chip is the surface that drifted.
//
// Format: "M:SS" (single-digit minutes, zero-padded seconds). FPS defaults
// to 30 to match TIMELINE_FPS / PREVIEW_FPS used elsewhere.

const DEFAULT_FPS = 30;

export function formatTimeFromFrame(frame, fps = DEFAULT_FPS) {
  if (frame == null) return null;
  const totalSeconds = Math.max(0, Math.round(Number(frame) / fps));
  const mm = Math.floor(totalSeconds / 60);
  const ss = totalSeconds % 60;
  return `${mm}:${ss < 10 ? "0" : ""}${ss}`;
}
